import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import ICONS from '../app/common/constants/icons';
import { PageId } from '../config/constants/pageId.enum';
import AccountSecurityContainer from '../details/accountSecurity/AccountSecurityContainer';
import AddressListContainer from '../details/addresses/addressList/AddressListContainer';
import AddressListJPContainer from '../details/addresses/addressListJP/AddressListJPContainer';
import CancelMembershipContainer from '../details/cancelMembership/CancelMembershipContainer';
import PaymentMethodsContainer from '../details/paymentMethods/PaymentMethodsContainer';
import PersonalInfoContainer from '../details/personalInfo/PersonalInfoContainer';
import {
    RakutenServiceContainer,
    UCRMContainer,
} from '../details/privacyCenter/PrivacyCenterContainer';
import RakutenServicesContainer from '../details/privacyCenter/rakutenServices/legacy/RakutenServicesContainer';
import { RewardsClub } from '../details/rewardsClub/RewardsClub';
import IdentityVerificationContainer from '../details/identityVerification/IdentityVerificationContainer';
import SocialAccountsContainerAP from '../details/socialAccounts/SocialAccountsContainerAP';
import { TranslationHelpers } from '../i18n/translationHelpers';

const routes: IRoute[] = [
    {
        component: PersonalInfoContainer,
        icon: ICONS.PERSONAL_INFORMATION,
        id: PageId.profile,
        name: TranslationHelpers.getMessageDescriptor('profile.info'),
        path: '/personal-information',
        text: TranslationHelpers.getMessageDescriptor('profile.edit_info'),
        order: 0,
        title: 'profile.title',
    },
    {
        component: AccountSecurityContainer,
        icon: ICONS.ACCOUNT_AND_SECURITY,
        id: PageId.security,
        name: TranslationHelpers.getMessageDescriptor('profile.account'),
        path: '/account-security',
        text: TranslationHelpers.getMessageDescriptor('profile.manage_account'),
        order: 1,
        title: 'account.title',
    },
    {
        component: RewardsClub,
        icon: ICONS.CASHBACK_AND_POINTS,
        id: PageId.cashbackAndPoints,
        name: TranslationHelpers.getMessageDescriptor('points.cashback_and_points'),
        path: '/cashback-and-rewards',
        text: TranslationHelpers.getMessageDescriptor('points.cashback_and_points'),
        order: 2,
        title: 'cashback.points.title',
    },
    {
        component: RewardsClub,
        icon: ICONS.POINTS_CLUB,
        id: PageId.points,
        name: TranslationHelpers.getMessageDescriptor('profile.points_club'),
        path: '/points-club',
        text: TranslationHelpers.getMessageDescriptor('profile.points_check'),
        order: 3,
        title: 'points.title',
    },
    {
        component: RakutenServicesContainer,
        icon: ICONS.RAKUTEN_SERVICES,
        id: PageId.services,
        name: TranslationHelpers.getMessageDescriptor('profile.services'),
        path: '/services',
        text: TranslationHelpers.getMessageDescriptor('profile.view_services'),
        order: 4,
    },
    {
        component: RakutenServiceContainer,
        icon: ICONS.RAKUTEN_SERVICES,
        id: PageId.services_v2,
        name: TranslationHelpers.getMessageDescriptor('profile.services'),
        path: '/v2/services',
        text: TranslationHelpers.getMessageDescriptor('profile.view_services'),
        order: 5,
    },
    {
        component: UCRMContainer,
        icon: ICONS.RAKUTEN_SERVICES,
        id: PageId.ucrm,
        name: TranslationHelpers.getMessageDescriptor('profile.ucrm'),
        path: '/services-privacy',
        text: TranslationHelpers.getMessageDescriptor('profile.view_ucrm'),
        order: 6,
        title: 'ucrm.title',
    },
    {
        component: AddressListContainer,
        icon: ICONS.ADDRESSES1,
        id: PageId.address,
        name: TranslationHelpers.getMessageDescriptor('profile.addresses'),
        path: '/addresses',
        text: TranslationHelpers.getMessageDescriptor('profile.manage_address'),
        order: 7,
        title: 'address.eu.title',
    },
    {
        component: AddressListJPContainer,
        icon: ICONS.ADDRESSES,
        id: PageId.address_jp,
        name: TranslationHelpers.getMessageDescriptor('profile.addresses'),
        path: '/addresses/jp',
        text: TranslationHelpers.getMessageDescriptor('profile.manage_address'),
        order: 8,
        title: 'address.title',
    },
    {
        component: PaymentMethodsContainer,
        icon: ICONS.PAYMENT_METHODS,
        id: PageId.cards,
        name: TranslationHelpers.getMessageDescriptor('profile.payment'),
        path: '/payments',
        text: TranslationHelpers.getMessageDescriptor('profile.manage_payment'),
        order: 9,
        title: 'payment.title',
    },
    {
        component: CancelMembershipContainer,
        icon: ICONS.ACCOUNT_AND_SECURITY,
        id: PageId.cancel_membership,
        isRender: true,
        name: TranslationHelpers.getMessageDescriptor('profile.account'),
        path: '/account-security/delete',
        text: TranslationHelpers.getMessageDescriptor('profile.manage_account'),
        order: 10,
        title: 'cancel.title',
    },
    {
        component: IdentityVerificationContainer,
        icon: ICONS.EKYC,
        id: PageId.ekyc,
        name: TranslationHelpers.getMessageDescriptor('profile.ekyc'),
        path: '/ekyc',
        text: TranslationHelpers.getMessageDescriptor('profile.manage_ekyc'),
        order: 11,
        title: 'ekyc.title',
    },
    {
        component: SocialAccountsContainerAP,
        icon: ICONS.RAKUTEN_SERVICES,
        id: PageId.linked_accounts,
        name: TranslationHelpers.getMessageDescriptor('profile.linked_accounts'),
        path: '/social-account-linkage-management',
        text: TranslationHelpers.getMessageDescriptor('profile.view_linked_accounts'),
        order: 12,
        title: 'linked.accounts.title',
    },
];

export interface IRoute {
    component: ReactNode;
    icon: string[];
    id: string;
    name: FormattedMessage.MessageDescriptor;
    path: string;
    text: FormattedMessage.MessageDescriptor;
    isRender?: boolean;
    order: number;
    title?: string;
}

export default routes;
